// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer__2dyxG","settingsLink":"Footer__settingsLink__20EXo","logoText":"Footer__logoText__3eLfn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.css
// module id = 861
// module chunks = 0